import { render, staticRenderFns } from "./CreationHistoryList.vue?vue&type=template&id=6ca03a1c"
import script from "./CreationHistoryList.vue?vue&type=script&lang=ts"
export * from "./CreationHistoryList.vue?vue&type=script&lang=ts"
import style0 from "./CreationHistoryList.vue?vue&type=style&index=0&id=6ca03a1c&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports